/**
 * FilterPopup - Основной параметрический фильтр.
 */

import MultiSelect from 'components/forms/multi-select';
import Observer from 'common/scripts/mediator';
import RangeSlider from 'components/range-slider';
import Utils from 'common/scripts/utils';

const observer = new Observer();

class FilterPopup {
    // eslint-disable-next-line max-statements
    constructor(options) {
        this.options = options;
        this.containerSelector = '.j-parametric-popup';
        this.container = options.wrapper ? options.wrapper.querySelector(this.containerSelector) : null;
        this.closeSelector = '.j-parametric-popup-close';
        this.formSelector = '.j-parametric-form';
        this.tabSelector = '.j-parametric-popup-tab';
        this.tabActiveClass = 'parametric-popup__tab-active';
        this.priceWrapSelector = '.j-parametric-price-wrap';
        this.payWrapSelector = '.j-parametric-pay-wrap';
        this.insrallmentWrapSelector = '.j-parametric-installment-wrap';
        this.clearSelector = '.j-parametric-clear';
        this.clearNowSelector = '.j-parametric-clear-now';
        this.submitSelector = '.j-parametric-submit';
        this.opensBtnSelector = '.j-parametric-filter-popup-open';

        this.stickyBtnWrapSelector = '.j-parametric-submit-sticky-wrap';
        this.stickyBtnSelector = '.j-parametric-submit-sticky';
        this.stickyClass = 'parametric-popup__view-sticky_is_fix';

        this.featureSelector = '.j-parametric-feature';
        this.termSelector = '.j-parametric-term';
        this.installmentSelector = '.j-parametric-installment';
        this.priceSelector = '.j-parametric-price';
        this.paySelector = '.j-parametric-pay';
        this.areaSelector = '.j-parametric-area';
        this.floorSelector = '.j-parametric-floor';
        this.roomSelector = '.j-filter-popup-room';

        this.nameTabEdit = 'price';
        this.changedFilters = [];

        this.init();
    }

    init() {
        if (!this.container) {
            return;
        }

        this._initElements();
        this._initMultiSelect();
        this._iniRangeSliders();
        this._setStickyBtn();
        this._bindEvents();
    }

    _initElements() {
        this.form = this.container.querySelector(this.formSelector);
        this.stickyBtnWrap = this.container.querySelector(this.stickyBtnWrapSelector);
        this.stickyBtn = this.container.querySelector(this.stickyBtnSelector);
        this.closeEls = Array.from(this.container.querySelectorAll(this.closeSelector));
        this.rooms = Array.from(this.container.querySelectorAll(this.roomSelector));
        this.tabs = Array.from(this.container.querySelectorAll(this.tabSelector));
        this.clears = Array.from(document.querySelectorAll(this.clearSelector));
        this.clearsNow = Array.from(document.querySelectorAll(this.clearNowSelector));
        this.submit = document.querySelector(this.submitSelector);
        this.opensBtns = Array.from(document.querySelectorAll(this.opensBtnSelector));

        this.priceWrap = this.container.querySelector(this.priceWrapSelector);
        this.payWrap = this.container.querySelector(this.payWrapSelector);
        this.insrallmentWrap = this.container.querySelector(this.insrallmentWrapSelector);
    }

    _initMultiSelect() {
        if (document.querySelector(this.featureSelector)) {
            this.features = new MultiSelect({
                container  : this.featureSelector,
                afterChange: (val) => {
                    this.featuresEditData = val;

                    this._change();
                }
            });

            this.features.init();
            this.featuresSafeData = this.features.getValues();
            this.featuresEditData = this.features.getValues();
        }

        if (document.querySelector(this.termSelector)) {
            this.term = new MultiSelect({
                container  : this.termSelector,
                afterChange: (val) => {
                    this.termEditData = val;

                    this._change();
                }
            });

            this.term.init();
            this.termSafeData = this.term.getValues();
            this.termEditData = this.term.getValues();
        }

        if (document.querySelector(this.installmentSelector)) {
            this.installment = new MultiSelect({
                container  : this.installmentSelector,
                afterChange: (val) => {
                    this.installmentEditData = val;

                    this._change();
                }
            });

            this.installment.init();
            this.installmentSafeData = this.installment.getValues();
            this.installmentEditData = this.installment.getValues();
        }
    }

    // eslint-disable-next-line max-lines-per-function
    _iniRangeSliders() {
        if (document.querySelector(this.priceSelector)) {
            this.price = new RangeSlider();

            this.price.init({
                name    : 'parametricPrice',
                wrapper : this.priceSelector,
                onFinish: (val) => {
                    this.priceEditData = {
                        ...val,
                        double: false
                    };

                    this._change();
                }
            });

            this.priceSafeData = this.price.getValues();
            this.priceEditData = this.price.getValues();
        }

        if (document.querySelector(this.paySelector)) {
            this.pay = new RangeSlider();

            this.pay.init({
                name    : 'parametricPay',
                wrapper : this.paySelector,
                onFinish: (val) => {
                    this.payEditData = {
                        ...val,
                        double: false
                    };

                    this._change();
                }
            });

            this.paySafeData = this.pay.getValues();
            this.payEditData = this.pay.getValues();
        }

        if (document.querySelector(this.areaSelector)) {
            this.area = new RangeSlider();

            this.area.init({
                name    : 'parametricArea',
                wrapper : this.areaSelector,
                onFinish: (val) => {
                    this.areaEditData = {
                        ...val,
                        double: true
                    };

                    this._change();
                }
            });

            this.areaSafeData = this.area.getValues();
            this.areaEditData = this.area.getValues();
        }

        if (document.querySelector(this.floorSelector)) {
            this.floor = new RangeSlider();

            this.floor.init({
                name    : 'parametricFloor',
                wrapper : this.floorSelector,
                onFinish: (val) => {
                    this.floorEditData = {
                        ...val,
                        double: true
                    };

                    this._change();
                }
            });

            this.floorSafeData = this.floor.getValues();
            this.floorEditData = this.floor.getValues();
        }
    }

    _initRooms() {
        this.roomsSafeData = this._getRooms();
        this.roomsEditData = this._getRooms();

        this.rooms.forEach((room) => {
            room.addEventListener('change', () => {
                const checked = this.rooms.filter((item) => {
                    return item.checked;
                });

                this.roomsEditData = checked.map((item) => {
                    return item.value;
                });
                this._change();
            });
        });
    }

    _getRooms() {
        const checkedEls = this.rooms.filter((item) => {
            return item.checked;
        });

        return checkedEls.map((item) => {
            return item.value;
        });
    }

    // eslint-disable-next-line max-lines-per-function
    _bindEvents() {
        this.form.addEventListener('submit', (event) => {
            event.preventDefault();

            this._send();
        });

        this.container.addEventListener('scroll', this._setStickyBtn.bind(this));
        window.addEventListener('resize', this._setStickyBtn.bind(this));

        this.closeEls.forEach((closeEl) => {
            closeEl.addEventListener('click', this.close.bind(this, true));
        });

        this._initRooms();

        observer.subscribe('filter-param:features', (val) => {
            this.features.setVal(val);

            this.featuresSafeData = val;
            this.featuresEditData = val;

            this.calcCountChangeFilter([{
                type : 'select',
                name : 'features',
                value: val
            }]);
        });

        observer.subscribe('filter-param:price', (val) => {
            this.price.setValues(val);

            this.priceSafeData = val;
            this.priceEditData = val;

            this.calcCountChangeFilter([{
                type : 'slider',
                name : 'price',
                value: val
            }]);
        });

        observer.subscribe('filter-param:pay', (val) => {
            this.pay.setValues(val);

            this.paySafeData = val;
            this.payEditData = val;

            this.calcCountChangeFilter([{
                type : 'slider',
                name : 'pay',
                value: val
            }]);
        });

        observer.subscribe('filter-param:area', (val) => {
            this.area.setValues(val);

            this.areaSafeData = val;
            this.areaEditData = val;

            this.calcCountChangeFilter([{
                type : 'slider',
                name : 'area',
                value: val
            }]);
        });

        observer.subscribe('filter-param:rooms', (val) => {
            this.setRooms(val);

            this.roomsSafeData = val;
            this.roomsEditData = val;

            this.calcCountChangeFilter([{
                type : 'select',
                name : 'rooms',
                value: val
            }]);
        });

        observer.subscribe('addition-filters:remove', (name) => {
            if (name === 'term') {
                this.term.reset();

                this.termEditData = this.term.getValues();
            }

            if (name === 'installment') {
                this.installment.reset();

                this.installmentEditData = this.installment.getValues();
            }

            if (name === 'floor') {
                this.floor.reset();

                this.floorEditData = this.floor.getValues();
            }

            if (name === 'pay') {
                this.pay.reset();

                this.payEditData = this.pay.getValues();

                this.nameTabEdit = 'price';

                this._setTabByName('price');
            }

            this._send();
        });

        this.tabs.forEach((tab) => {
            if (tab.classList.contains(this.tabActiveClass)) {
                this.nameTab = tab.dataset.tab;
            }

            tab.addEventListener('click', this._clickTab.bind(this, tab));
        });

        this.clears.forEach((clear) => {
            clear.addEventListener('click', () => {
                this.clearFilter();

                this.changedFilters = [];
            });
        });

        this.clearsNow.forEach((clear) => {
            clear.addEventListener('click', () => {
                this.clearFilter();
                this._send(false);

                this.changedFilters = [];
            });
        });

        this.opensBtns.forEach((opensBtn) => {
            opensBtn.addEventListener('click', this.open.bind(this));
        });
    }

    _setStickyBtn() {
        if (window.innerWidth >= 670) {
            this._removeStickyBtn();

            return;
        }

        const height = this.stickyBtn.offsetHeight;
        const bottomSticky = this.stickyBtnWrap.getBoundingClientRect().top - window.innerHeight + height;

        if (bottomSticky > 0) {
            this.stickyBtnWrap.style.height = `${height}px`;
            this.stickyBtn.classList.add(this.stickyClass);
        } else {
            this._removeStickyBtn();
        }
    }

    _removeStickyBtn() {
        this.stickyBtnWrap.removeAttribute('style');
        this.stickyBtn.classList.remove(this.stickyClass);
    }

    open() {
        Utils.show(this.container);
        Utils.bodyFixed(this.container);
        this._setStickyBtn();
    }

    close(reset) {
        Utils.hide(this.container);
        Utils.bodyStatic();

        if (reset) {
            this._resetToSaveData();
        }
    }

    setRooms(values = []) {
        this.rooms.forEach((room) => {
            room.checked = values.indexOf(room.value) !== -1;
        });
    }

    _resetToSaveData() {
        this.features.setVal(this.featuresSafeData);
        this.term.setVal(this.termSafeData);
        this.installment.setVal(this.installmentSafeData);
        this.price.setValues(this.priceSafeData);
        this.pay.setValues(this.paySafeData);
        this.area.setValues(this.areaSafeData);
        this.floor.setValues(this.floorSafeData);
        this.setRooms(this.roomsSafeData);

        this._setTabByName(this.nameTab);
    }

    _change() {
        if (this.options.afterChange) {
            this.options.afterChange();
        }
    }

    _send(close = true) {
        observer.publish('filter-popup:features', this.featuresEditData);
        observer.publish('filter-popup:rooms', this.roomsEditData);
        observer.publish('filter-popup:area', this.areaEditData);
        observer.publish('filter-popup:price', this.priceEditData);
        observer.publish('filter-popup:pay', this.payEditData);

        // Кол-во измененых фильтров
        this.calcCountChangeFilter([{
            type : 'select',
            name : 'features',
            value: this.featuresEditData
        }, {
            type : 'select',
            name : 'rooms',
            value: this.roomsEditData
        }, {
            type : 'slider',
            name : 'area',
            value: this.areaEditData
        }, {
            type : 'slider',
            name : 'price',
            value: this.priceEditData
        }, {
            type : 'slider',
            name : 'pay',
            value: this.payEditData
        }, {
            type : 'select',
            name : 'term',
            value: this.termEditData
        }, {
            type : 'select',
            name : 'installment',
            value: this.installmentEditData
        }, {
            type : 'slider',
            name : 'floor',
            value: this.floorEditData
        }]);

        observer.publish('filter-popup:change-tab', this.nameTabEdit);

        this._sendInAddition();
        this._actualData();

        if (close) {
            this.close();
        }

        if (this.options.afterSubmit) {
            this.options.afterSubmit();
        }
    }

    /**
     * Отправляю данные фильтров обсервером в addition-filter для вывода в filter param
     */
    _sendInAddition() {
        observer.publish('filter-popup:term', {
            name   : 'term',
            caption: 'Срок сдачи',
            value  : this.termEditData.join(', ')
        });

        observer.publish('filter-popup:installment', {
            name   : 'installment',
            caption: 'Срок рассрочки',
            value  : this.installmentEditData.join(', ')
        });

        let floorValue = false;

        /* проверка, не стоит ли слайдер с дефолтными значениями */
        if (!(this.floorEditData.from === this.floorEditData.min && this.floorEditData.to === this.floorEditData.max)) {
            floorValue = `с ${this.floorEditData.from} по ${this.floorEditData.to}`;
        }

        observer.publish('filter-popup:floor', {
            name   : 'floor',
            caption: 'Этаж',
            value  : floorValue
        });

        observer.publish('filter-popup:pay', {
            name   : 'pay',
            caption: 'Первый взнос',
            post   : '₴',
            value  : this.nameTabEdit === 'pay' ? this.payEditData.from_pretty : false
        });
    }

    _actualData() {
        this.featuresSafeData = this.featuresEditData;
        this.termSafeData = this.termEditData;
        this.installmentSafeData = this.installmentEditData;
        this.roomsSafeData = this.roomsEditData;
        this.areaSafeData = {...this.areaEditData};
        this.priceSafeData = {...this.priceEditData};
        this.paySafeData = {...this.payEditData};
        this.floorSafeData = {...this.floorEditData};

        this.nameTab = this.nameTabEdit;
    }

    async _clickTab(tab) {
        if (tab.classList.contains(this.tabActiveClass)) {
            return;
        }

        await this._hideForm();

        this.nameTabEdit = tab.dataset.tab;

        this._setTabByName(this.nameTabEdit);

        this._showForm();
    }

    _hideForm() {
        const duration = 200;

        return new Promise((resolve) => {
            this.form.classList.add('is-hide');

            setTimeout(() => {
                resolve();
            }, duration);
        }, duration);
    }

    _showForm() {
        this.form.classList.remove('is-hide');
    }

    _setTabByName(name) {
        this.tabs.forEach((item) => {
            if (item.dataset.tab === name) {
                item.classList.add(this.tabActiveClass);
                item.click();
            } else {
                item.classList.remove(this.tabActiveClass);
            }
        });

        if (name === 'price') {
            Utils.show(this.priceWrap);
            Utils.hide(this.payWrap);
            Utils.hide(this.insrallmentWrap);
            this.form.classList.remove('parametric-popup__form_is_pay');
        } else {
            Utils.hide(this.priceWrap);
            Utils.show(this.payWrap);
            Utils.show(this.insrallmentWrap);
            this.form.classList.add('parametric-popup__form_is_pay');
        }
    }

    clearFilter() {
        this.features.reset();
        this.term.reset();
        this.installment.reset();
        this.price.reset();
        this.pay.reset();
        this.area.reset();
        this.floor.reset();
        this.setRooms([]);

        this._actualEditsData();
    }

    _actualEditsData() {
        this.featuresEditData = this.features.getValues();
        this.termEditData = this.term.getValues();
        this.installmentEditData = this.installment.getValues();
        this.roomsEditData = this._getRooms();
        this.areaEditData = this.area.getValues();
        this.priceEditData = this.price.getValues();
        this.payEditData = this.pay.getValues();
        this.floorEditData = this.floor.getValues();
    }

    replaceSubmitText(text) {
        Utils.clearHtml(this.submit);
        Utils.insetContent(this.submit, text);
    }

    disableButton() {
        this.submit.classList.add('is-disabled');
    }

    enableButton() {
        this.submit.classList.remove('is-disabled');
    }

    calcCountChangeFilter(filters = []) {
        filters.forEach((filter) => {
            if (filter.type === 'select') {
                if (filter.value.length) {
                    this.changedFilters = this.appendInArray(this.changedFilters, filter.name);
                } else {
                    this.changedFilters = this.removeInArray(this.changedFilters, filter.name);
                }
            } else if (filter.type === 'slider') {
                if (filter.value['double']) {
                    if (filter.value.from === filter.value.min && filter.value.to === filter.value.max) {
                        this.changedFilters = this.removeInArray(this.changedFilters, filter.name);
                    } else {
                        this.changedFilters = this.appendInArray(this.changedFilters, filter.name);
                    }
                } else if (filter.value.from === filter.value.max) {
                    this.changedFilters = this.removeInArray(this.changedFilters, filter.name);
                } else {
                    this.changedFilters = this.appendInArray(this.changedFilters, filter.name);
                }
            }
        });

        observer.publish('filter-popup:changeCountFilter', this.changedFilters.length);
    }

    appendInArray(array, value) {
        const idx = array.indexOf(value);

        if (idx === -1) {
            array.push(value);
        }

        return array;
    }

    removeInArray(array, value) {
        const idx = array.indexOf(value);

        if (idx !== -1) {
            array.splice(idx, 1);
        }

        return array;
    }
}

export default FilterPopup;
